import { render, staticRenderFns } from "./PersonSearch.vue?vue&type=template&id=b376ced8&"
import script from "./PersonSearch.vue?vue&type=script&lang=ts&"
export * from "./PersonSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports